import { useState } from "react";
import { AdminAPI } from "../utils/adminApi";

const BroadcastEmail = () => {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleSend = async () => {
    if (!subject || !message) {
      alert("Subject and message required");
      return;
    }

    const confirmSend = window.confirm(
      "⚠️ This will send email to ALL active users. Continue?"
    );

    if (!confirmSend) return;

    try {
      setLoading(true);
      setResult(null);

      // ✅ IMPORTANT: correct endpoint
      const res = await AdminAPI.post("/send-email-all", {
  subject,
  message,
});

      setResult(res.data);

      setSubject("");
      setMessage("");
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || "❌ Failed to send email");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: "600px", margin: "40px auto" }}>
      <h2>📩 Broadcast Email</h2>

      <p style={{ color: "red", fontSize: "14px" }}>
        ⚠️ This will send email to ALL active users
      </p>

      <input
        type="text"
        placeholder="Enter subject"
        value={subject}
        onChange={(e) => setSubject(e.target.value)}
        style={{
          width: "100%",
          padding: "12px",
          marginBottom: "10px",
          borderRadius: "6px",
        }}
      />

      <textarea
        placeholder="Enter your message..."
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        rows={6}
        style={{
          width: "100%",
          padding: "12px",
          marginBottom: "10px",
          borderRadius: "6px",
        }}
      />

      <button
        onClick={handleSend}
        disabled={loading}
        style={{
          width: "100%",
          padding: "12px",
          borderRadius: "6px",
          background: "#0046ff",
          color: "#fff",
          border: "none",
        }}
      >
        {loading ? "Sending..." : "Send to All Users"}
      </button>

      {result && (
        <div style={{ marginTop: "20px", color: "green" }}>
          <p>{result.message}</p>
          <p>Total: {result.total}</p>
          <p>Success: {result.success}</p>
          <p>Failed: {result.failed}</p>
        </div>
      )}
    </div>
  );
};

export default BroadcastEmail;
